import { connect } from 'react-redux';
import _get from 'lodash-es/get';
import DeleteProgramModal from './DeleteProgramModal';
import { updateProgramStatusInitiate } from '../../../actions/programs';

const mapStateToProps = state => ({
  updatingProgramStatus:
    _get(state, 'apiState.UPDATE_PROGRAM_STATUS.isFetching', false) &&
    !_get(state, 'apiState.UPDATE_PROGRAM_STATUS.isIdle', false),
  updateProgramStatusSuccess: _get(
    state,
    'apiState.UPDATE_PROGRAM_STATUS.success',
    false,
  ),
});

const mapDispatchToProps = dispatch => ({
  updateProgram: payload => dispatch(updateProgramStatusInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteProgramModal);
